import { computed, toRefs } from '@vue/composition-api'

import AuthService from '@/core/auth/AuthService'
import { authState } from '@/core/auth/authState'

export function useAuth() {
    // Вычисляемые свойства
    const userFullName = computed(() => {
        if (!authState.user) return ''
        const { first_name: firstName, last_name: lastName } = authState.user
        return `${firstName || ''} ${lastName || ''}`.trim()
    })

    const userLogin = computed(() => {
        return authState.user?.login || ''
    })

    // Методы
    const logout = async () => {
        try {
            await AuthService.logout()
        } catch (error) {
            console.error('Logout error:', error)
        }
    }

    const hasPermission = permission => {
        return authState.permissions.includes(permission)
    }

    return {
        // Состояние
        ...toRefs(authState),

        // Вычисляемые свойства
        userFullName,
        userLogin,

        // Методы
        logout,
        hasPermission,

        // Сервис (для прямого доступа к методам)
        authService: AuthService,
    }
}
